/*
 * @Author: your name
 * @Date: 2020-12-11 14:39:34
 * @LastEditTime: 2022-11-08 16:42:31
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/router/redirect-list/index.js
 */

// Route Redirection
// 路由重定向
// Write out the situation of each route, and write the page to jump in redirect - name
// 把每种路由的情况都写出，并在 'redirect - name' 中写上要跳转的页面
export const redirectList = [
  {
    path: '/v/:venueId/home/',
    alias: ['/online/v/:venueId/home/', '/r/v/:venueId/home/', '/v/o/:venueId/home/'],
    redirect: {
      name: 'venue-home-pick'
    }
  },
  {
    path: '/v/whitsundays',
    params: { venueId: 'whitsundays' },
    redirect: {
      name: 'venue-home-pick',
      params: { venueId: 'whitsundays' }
    }
  },
  {
    path: '/v/:venueId/c',
    alias: ['/online/v/:venueId/', '/r/v/:venueId/', '/v/o/:venueId/'],
    redirect: {
      name: 'venue-home-pick'
    }
  },
  {
    path: '/v/:venueId/p',
    alias: ['/online/v/:venueId/p', '/r/v/:venueId/home/', '/v/o/:venueId/p'],
    redirect: {
      name: 'venue-home-pick'
    }
  },
  {
    path: '/v/:venueId/t/:number',
    alias: ['/online/v/:venueId/t/:number', '/r/v/:venueId/home/'],
    redirect: {
      name: 'venue-home-table'
    }
  },
  {
    path: '/v/:venueId/tab/:tabId',
    alias: ['/online/v/:venueId/tab/:tabId', '/r/v/:venueId/home/'],
    redirect: {
      name: 'tab-code'
    }
  },
]
